/**
 * Dashboard MV2 QueryClient singleton.
 */
import { makeMv2QueryClient } from "@/features/_mv2/makeQueryClient";
import { setupMv2CachePersist } from "@/features/_mv2/mv2CachePersist";
import { DASHBOARD_QUERY_KEY, fetchDashboardFromApi } from "./dashboardQueryApi";

export const dashboardQueryClient = makeMv2QueryClient();
setupMv2CachePersist(dashboardQueryClient, "dashboard");

export function prefetchDashboard() {
  return dashboardQueryClient.prefetchQuery({
    queryKey: [DASHBOARD_QUERY_KEY],
    queryFn: ({ signal }) => fetchDashboardFromApi(signal),
  });
}
